
define('text!templates/pages/basket/basket-collection.ejs',[],function () { return '<div class="loading alert">Загрузка</div>\n<div class="empty alert">В корзине товара нет.</div>';});

